import React from "react";
import PropTypes from "prop-types";
import { Typography, Box } from "@material-ui/core";
import { COLORS, SPACING } from "../constants";
import { Btn } from "./UI";
import { useStyles } from "../views/wizard-view.style";

export function WizardDoneStep({ wizardSelectedTemplate, wizardLeafs, wizardMode, wizardApplyErrors, wizardUnresolvedServiceIds, wizardUnresolvedResourceIds, wizardReset, setTab }) {
  const classes = useStyles();
  return (
    <Box className={classes.doneContainer}>
      <Box className={classes.doneIcon}>&#10003;</Box>
      <Typography variant="h6" sx={{ fontWeight: 700, color: COLORS.successDark, marginBottom: `${SPACING.formGroupGap}px` }}>
        Applied Successfully
      </Typography>
      <Typography variant="body2" sx={{ color: COLORS.muted, marginBottom: `${SPACING.formGroupGap}px` }}>
        &ldquo;{wizardSelectedTemplate?.name}&rdquo; applied to {wizardLeafs.length} location(s) via {wizardMode}.
      </Typography>
      {wizardApplyErrors.length > 0 && (
        <Box className={classes.errorBox}>
          <Typography variant="caption" sx={{ fontWeight: 600, color: COLORS.warn, marginBottom: '8px', display: 'block' }}>
            {wizardApplyErrors.length} location(s) failed
          </Typography>
          <Box component="ul" sx={{ margin: 0, paddingLeft: '20px', fontSize: 12, color: COLORS.body }}>
            {wizardApplyErrors.map((err) => (
              <Typography component="li" variant="caption" key={`${err.locationId}-${err.message}`}>
                <Box component="span" sx={{ fontWeight: 700 }}>{err.locationId}</Box>: {err.message}
              </Typography>
            ))}
          </Box>
        </Box>
      )}
      {(wizardUnresolvedServiceIds?.length > 0 || wizardUnresolvedResourceIds?.length > 0) && (
        <Box className={classes.infoBox}>
          <Typography variant="caption" sx={{ fontWeight: 600, color: COLORS.info, marginBottom: '6px', display: 'block' }}>
            Skipped (not in catalog)
          </Typography>
          {wizardUnresolvedServiceIds?.length > 0 && (
            <Typography variant="caption">Services (IDs): {wizardUnresolvedServiceIds.join(", ")}</Typography>
          )}
          {wizardUnresolvedResourceIds?.length > 0 && (
            <Typography variant="caption">Resources (IDs): {wizardUnresolvedResourceIds.join(", ")}</Typography>
          )}
        </Box>
      )}
      <Box className={classes.doneActions}>
        <Btn variant="outlined" onClick={wizardReset}>Apply Another</Btn>
        <Btn onClick={() => { setTab("browse"); wizardReset(); }}>Browse Locations</Btn>
      </Box>
    </Box>
  );
}

WizardDoneStep.propTypes = {
  wizardSelectedTemplate: PropTypes.shape({
    name: PropTypes.string,
    services: PropTypes.array,
    resources: PropTypes.array,
  }),
  wizardLeafs: PropTypes.array,
  wizardMode: PropTypes.string,
  wizardApplyErrors: PropTypes.array,
  wizardUnresolvedServiceIds: PropTypes.array,
  wizardUnresolvedResourceIds: PropTypes.array,
  wizardReset: PropTypes.func.isRequired,
  setTab: PropTypes.func.isRequired,
};

WizardDoneStep.defaultProps = {
  wizardSelectedTemplate: null,
  wizardLeafs: [],
  wizardMode: "merge",
  wizardApplyErrors: [],
  wizardUnresolvedServiceIds: [],
  wizardUnresolvedResourceIds: [],
};
